import { render, staticRenderFns } from "./WorkPlat.vue?vue&type=template&id=59d93815&scoped=true&"
import script from "./WorkPlat.vue?vue&type=script&lang=js&"
export * from "./WorkPlat.vue?vue&type=script&lang=js&"
import style0 from "./WorkPlat.vue?vue&type=style&index=0&id=59d93815&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59d93815",
  null
  
)

export default component.exports